import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "@/lib/api";

/**
 * Auth gate around the parse / translate / validate pages. If no JWT
 * is in localStorage (the canonical "logged out" signal), redirect to
 * /login and remember the requested path so we can return after a
 * successful sign-in.
 *
 * <p>Pairs with the axios 401 interceptor in lib/api.ts: if the token
 * exists but the server says it's invalid (expired, signed by a
 * rotated key), the interceptor clears it and bounces to /login —
 * the next render of this guard finds no token and stays put.
 */
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
